export interface ValidationRule {
  name: string;
  condition: any;
  message: string;
}

export class PaxFormControlBase<T> {
  value: T;
  key: string;
  label: string;
  placeholder: string;
  validation: ValidationRule[];
  layout: string;
  order: number;
  controlType: string;
  mask: string;
  tooltip: string;
  maxLength: string;
  readonly: boolean;

  constructor(options: {
    value?: T,
    key?: string,
    label?: string,
    placeholder?: string,
    validation?: ValidationRule[];
    layout?: string,
    order?: number,
    controlType?: string
    mask?: string
    tooltip?: string
    maxLength?: string
    readonly?: boolean
  } = {}) {
    this.value = options.value;
    this.key = options.key || '';
    this.label = options.label || '';
    this.placeholder = options.placeholder || '';
    this.validation = options.validation || [];
    this.layout = options.layout === undefined ? 'inline' : options.layout;
    this.order = options.order === undefined ? 1 : options.order;
    this.controlType = options.controlType || '';
    this.mask = options.mask || '';
    this.tooltip = options.tooltip || '';
    this.maxLength = options.maxLength || '';
    this.readonly = options.readonly || false;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/shared/pax-form-control/pax-form-control-base.ts